<template>
  <div class="manage_products">
    <h3 class="page-title">发布产品</h3>
    <div class="content">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="产品类型">
          <el-select v-model="form.region" placeholder="产品类型">
            <el-option
              v-for="option in select"
              :key="option.id"
              :label="option.name"
              :value="option.id"
            ></el-option>
            <!-- <el-option label="区域二" value="beijing"></el-option> -->
          </el-select>
          <el-button type="primary" icon="el-icon-plus" plain v-on:click="add_products_type">增加类型</el-button>
        </el-form-item>
        <el-form-item label="产品名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="产品图片">
          <el-upload
            action="upImg.php"
            show-file-list="true"
            list-type="picture-card"
            :file-list="fileList"
            :on-success="handleAvatarSuccess"
            :on-remove="delete_file"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <!-- <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt>
          </el-dialog>-->
        </el-form-item>
        <el-form-item label="产品描述">
          <el-input type="textarea" v-model="form.desc" :rows="10"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" style="margin-left:80px;" v-on:click="release">发布</el-button>
    </div>
  </div>
</template>
<style scoped>
.input {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 100%;
  font-size: 14px;
}
.input:focus {
  outline: none;
  border-color: #409eff;
}
.manage_products {
  width: 100%;
  height: 100%;
}
.page-title {
  padding-left: 100px;
  height: 50px;
  line-height: 50px;
  border: 1px solid #f2f2f2;
}
.content {
  width: 1000px;
  height: 500px;
  /* border: 1px solid #ccc; */
  margin: 20px auto;
}
</style>
<script>
export default {
  name: "manageProducts",
  data() {
    return {
      form: {
        region: "",
        name: "",
        desc: ""
      },
      /** 存放上传图片的列表*/
      fileList: [
        // {
        //   name: "food.jpeg",
        //   url: "upload/1250.jpg"
        // }
      ],
      img_path: [],
      /** 产品类型 */
      select: []
    };
  },
  methods: {
    /** 增加产品类型 */
    add_products_type() {
      var _this = this;
      this.$prompt("请输入类型名", "添加产品类型", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValidator: function(value) {
          if (value == "") {
          }
          var reg = /^\s+$/g;
          if (reg.test(value)) {
            return false;
          }
        }
      })
        .then(({ value }) => {
          var data = {
            name: value
          };
          $.ajax({
            url: "/product_type.php",
            type: "post",
            data: data,
            success: function(data, textStatus, jqXHR) {
              _this.$message({
                type: "success",
                message: "增加成功"
              });
              _this.$ajax("/product_type.php", "get", null, function(data) {
                _this.select = JSON.parse(data);
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消增加"
          });
        });
    },
    release() {
      var _this = this;
      var data = {
        product_name: this.form.name,
        pro_int: this.form.desc,
        type: this.form.region,
        image_path: this.img_path
      };
      this.$ajax("/release_product.php", "post", JSON.stringify(data), function(
        data
      ) {
        _this.$message({
          type: "success",
          message: "发布产品成功"
        });
        console.log(data);
      });
      // console.log(this.fileList);
    },
    handleAvatarSuccess(response, file, fileList) {
      this.img_path.push(response.replace(/\s/g, ""));
    },
    delete_file(file, fileList) {
      var data = {
        path: file.name
      };
      console.log(data);
      this.$ajax("/upImg.php", "delete", JSON.stringify(data), function(data) {
        console.log(data);
      });
    }
  },
  created() {
    /** 修改父组件，不显示头部，导航栏，底部 */
    this.$emit("public_header", false);
    this.$emit("public_nav", false);
    this.$emit("public_footer", false);
  },
  mounted() {
    var _this = this;
    var product_id = this.$route.query.id;
    if (product_id) {
      $.ajax({
        url: "/product.php?id=" + product_id,
        type: "get",
        success: function(data) {
          var pro = JSON.parse(data);
          _this.form.region = pro.type_id;
          _this.form.name = pro.product_name;
          _this.form.desc = pro.pro_int;

          for (let i = 0; i < pro.images.length; i++) {
            var img = pro.images[i];
            _this.fileList.push({
              name: img.path,
              url: img.path
            });
          }
        }
      });
    }

    /** 判断是否为 undefined */
    $.ajax({
      url: "/product_type.php",
      type: "get",
      //   data: "",
      success: function(data, textStatus, jqXHR) {
        _this.select = JSON.parse(data);
      }
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/manage_products.vue